module.exports = __webpack_public_path__ + "static/media/ls.4bcf7705.png";